<div class="mobile-game-header-menu" [ngClass]="{'opened': state}">

  <div class="mobile-game-header-menu__organization-info" *ngIf="schoolClassData">
    <div class="mobile-game-header-menu__organization-info-image">
      <brt-game-organization-logo [name]="schoolClassData.classNumber + ' ' + schoolClassData.classAddition"></brt-game-organization-logo>
    </div>

    <div class="mobile-game-header-menu__organization-info-content">
      <div class="mobile-game-header-menu__organization-info-name">
        {{schoolClassData.name}}
      </div>

      <div class="mobile-game-header-menu__organization-info-code">
        <brt-icon [icon]="'eye'"></brt-icon> {{schoolClassData.classCode}}
      </div>
    </div>
  </div>

  <div class="mobile-game-header-menu__menu-item" #professionItems>
    <div class="mobile-game-header-menu__menu-item-title" (click)="toggleMenuItem(professionItems)">
      <span>Spiele</span>
      <span><brt-icon [icon]="'reg-chevron-down'"></brt-icon></span>
    </div>
    <div class="mobile-game-header-menu__menu-item-content-wrapper">
      <div class="mobile-game-header-menu__menu-item-content">
        <div class="mobile-game-header-menu__menu-item-content-sub-item" *ngFor="let item of menuGames">
          <brt-submenu-item [data]="item"></brt-submenu-item>
        </div>
      </div>
    </div>
  </div>

  <div class="mobile-game-header-menu__menu-item" (click)="openRankingListOverlay()">
    <div class="mobile-game-header-menu__menu-item-title">
      <span>Rangliste</span>
    </div>
  </div>

  <div class="mobile-game-header-menu__menu-item" (click)="openTrophiesOverlay()">
    <div class="mobile-game-header-menu__menu-item-title">
      <span>Trophäen</span>
    </div>
  </div>



  <div class="mobile-game-header-menu__menu-item mobile-game-header-menu__menu-item--icons" [routerLink]="'/'">
    <div class="mobile-game-header-menu__menu-item-icon">
      <brt-icon [icon]="'link'" [add-blur]="true"></brt-icon>
    </div>
    <div class="mobile-game-header-menu__menu-item-label">berufsreise.at</div>
  </div>

  <div class="mobile-game-header-menu__menu-item mobile-game-header-menu__menu-item--icons" (click)="logout()">
    <div class="mobile-game-header-menu__menu-item-icon">
      <brt-icon [icon]="'logout'" [add-blur]="true"></brt-icon>
    </div>
    <div class="mobile-game-header-menu__menu-item-label">Logout</div>
  </div>

</div>
